import { Block } from "@babackapp/blocks-editor/types";
import { isBlockTranslated } from "@babackapp/editor-blocks-library/blocks";

/**
 * In v2 the dynamic-text block is left empty in the template and filled per
 * workflow. Once filled in any locale, its translations are checked again.
 */
export function isWorkflowManagedBlock(block: Block, locales: string[]) {
  return (
    block.type === "dynamic-text" &&
    !locales.some((locale) => isBlockTranslated(locale, block))
  );
}
